// Villes et communes de Madagascar — 22 régions + 119 districts + ~60 communes importantes
// Source: découpage administratif officiel de Madagascar

export const MADAGASCAR_CITIES = [
  // ===================== ANALAMANGA =====================
  { name: "Antananarivo", region: "Analamanga", major: true },
  { name: "Ambohidratrimo", region: "Analamanga" },
  { name: "Anjozorobe", region: "Analamanga" },
  { name: "Ankazobe", region: "Analamanga" },
  { name: "Andramasina", region: "Analamanga" },
  { name: "Manjakandriana", region: "Analamanga" },
  { name: "Antananarivo-Atsimondrano", region: "Analamanga" },
  { name: "Antananarivo-Avaradrano", region: "Analamanga" },
  { name: "Tanjombato", region: "Analamanga" },
  { name: "Ivato", region: "Analamanga" },
  { name: "Ambatolampy-Tsimahafotsy", region: "Analamanga" },

  // ===================== VAKINANKARATRA =====================
  { name: "Antsirabe", region: "Vakinankaratra", major: true },
  { name: "Ambatolampy", region: "Vakinankaratra" },
  { name: "Betafo", region: "Vakinankaratra" },
  { name: "Faratsiho", region: "Vakinankaratra" },
  { name: "Mandoto", region: "Vakinankaratra" },

  // ===================== ITASY =====================
  { name: "Miarinarivo", region: "Itasy" },
  { name: "Arivonimamo", region: "Itasy" },
  { name: "Soavinandriana", region: "Itasy" },

  // ===================== BONGOLAVA =====================
  { name: "Tsiroanomandidy", region: "Bongolava" },
  { name: "Fenoarivobe", region: "Bongolava" },

  // ===================== SOFIA =====================
  { name: "Antsohihy", region: "Sofia" },
  { name: "Analalava", region: "Sofia" },
  { name: "Bealanana", region: "Sofia" },
  { name: "Befandriana-Nord", region: "Sofia" },
  { name: "Boriziny (Port-Bergé)", region: "Sofia" },
  { name: "Mampikony", region: "Sofia" },
  { name: "Mandritsara", region: "Sofia" },

  // ===================== BOENY =====================
  { name: "Mahajanga", region: "Boeny", major: true },
  { name: "Ambato-Boeny", region: "Boeny" },
  { name: "Marovoay", region: "Boeny" },
  { name: "Mitsinjo", region: "Boeny" },
  { name: "Soalala", region: "Boeny" },

  // ===================== BETSIBOKA =====================
  { name: "Maevatanana", region: "Betsiboka" },
  { name: "Kandreho", region: "Betsiboka" },
  { name: "Tsaratanana", region: "Betsiboka" },

  // ===================== MELAKY =====================
  { name: "Maintirano", region: "Melaky" },
  { name: "Antsalova", region: "Melaky" },
  { name: "Besalampy", region: "Melaky" },
  { name: "Morafenobe", region: "Melaky" },
  { name: "Ambatomainty", region: "Melaky" },

  // ===================== DIANA =====================
  { name: "Antsiranana (Diego-Suarez)", region: "Diana", major: true },
  { name: "Ambanja", region: "Diana" },
  { name: "Ambilobe", region: "Diana" },
  { name: "Nosy Be", region: "Diana" },
  { name: "Hell-Ville", region: "Diana" },

  // ===================== SAVA =====================
  { name: "Sambava", region: "Sava" },
  { name: "Andapa", region: "Sava" },
  { name: "Antalaha", region: "Sava" },
  { name: "Vohemar", region: "Sava" },

  // ===================== ALAOTRA MANGORO =====================
  { name: "Ambatondrazaka", region: "Alaotra Mangoro" },
  { name: "Amparafaravola", region: "Alaotra Mangoro" },
  { name: "Andilamena", region: "Alaotra Mangoro" },
  { name: "Anosibe An'ala", region: "Alaotra Mangoro" },
  { name: "Moramanga", region: "Alaotra Mangoro" },

  // ===================== ANALANJIROFO =====================
  { name: "Fenerive-Est", region: "Analanjirofo" },
  { name: "Mananara Nord", region: "Analanjirofo" },
  { name: "Maroantsetra", region: "Analanjirofo" },
  { name: "Sainte-Marie (Nosy Boraha)", region: "Analanjirofo" },
  { name: "Soanierana-Ivongo", region: "Analanjirofo" },
  { name: "Vavatenina", region: "Analanjirofo" },

  // ===================== ATSINANANA =====================
  { name: "Toamasina (Tamatave)", region: "Atsinanana", major: true },
  { name: "Antanambao Manampotsy", region: "Atsinanana" },
  { name: "Brickaville", region: "Atsinanana" },
  { name: "Mahanoro", region: "Atsinanana" },
  { name: "Marolambo", region: "Atsinanana" },
  { name: "Vatomandry", region: "Atsinanana" },

  // ===================== AMORON'I MANIA =====================
  { name: "Ambositra", region: "Amoron'i Mania" },
  { name: "Ambatofinandrahana", region: "Amoron'i Mania" },
  { name: "Fandriana", region: "Amoron'i Mania" },
  { name: "Manandriana", region: "Amoron'i Mania" },

  // ===================== HAUTE MATSIATRA =====================
  { name: "Fianarantsoa", region: "Haute Matsiatra", major: true },
  { name: "Ambalavao", region: "Haute Matsiatra" },
  { name: "Ambohimahasoa", region: "Haute Matsiatra" },
  { name: "Ikalamavony", region: "Haute Matsiatra" },
  { name: "Isandra", region: "Haute Matsiatra" },
  { name: "Lalangina", region: "Haute Matsiatra" },
  { name: "Vohibato", region: "Haute Matsiatra" },

  // ===================== VATOVAVY =====================
  { name: "Mananjary", region: "Vatovavy" },
  { name: "Ifanadiana", region: "Vatovavy" },
  { name: "Nosy Varika", region: "Vatovavy" },

  // ===================== FITOVINANY =====================
  { name: "Manakara", region: "Fitovinany" },
  { name: "Ikongo", region: "Fitovinany" },
  { name: "Vohipeno", region: "Fitovinany" },

  // ===================== ATSIMO ATSINANANA =====================
  { name: "Farafangana", region: "Atsimo Atsinanana" },
  { name: "Befotaka", region: "Atsimo Atsinanana" },
  { name: "Midongy Atsimo", region: "Atsimo Atsinanana" },
  { name: "Vangaindrano", region: "Atsimo Atsinanana" },
  { name: "Vondrozo", region: "Atsimo Atsinanana" },

  // ===================== IHOROMBE =====================
  { name: "Ihosy", region: "Ihorombe" },
  { name: "Iakora", region: "Ihorombe" },
  { name: "Ivohibe", region: "Ihorombe" },

  // ===================== MENABE =====================
  { name: "Morondava", region: "Menabe", major: true },
  { name: "Belo-sur-Tsiribihina", region: "Menabe" },
  { name: "Mahabo", region: "Menabe" },
  { name: "Manja", region: "Menabe" },
  { name: "Miandrivazo", region: "Menabe" },

  // ===================== ATSIMO ANDREFANA =====================
  { name: "Toliara (Tuléar)", region: "Atsimo Andrefana", major: true },
  { name: "Ampanihy Ouest", region: "Atsimo Andrefana" },
  { name: "Ankazoabo Sud", region: "Atsimo Andrefana" },
  { name: "Benenitra", region: "Atsimo Andrefana" },
  { name: "Beroroha", region: "Atsimo Andrefana" },
  { name: "Betioky Sud", region: "Atsimo Andrefana" },
  { name: "Morombe", region: "Atsimo Andrefana" },
  { name: "Sakaraha", region: "Atsimo Andrefana" },

  // ===================== ANDROY =====================
  { name: "Ambovombe-Androy", region: "Androy" },
  { name: "Bekily", region: "Androy" },
  { name: "Beloha", region: "Androy" },
  { name: "Tsihombe", region: "Androy" },

  // ===================== ANOSY =====================
  { name: "Tolagnaro (Fort-Dauphin)", region: "Anosy", major: true },
  { name: "Amboasary Atsimo", region: "Anosy" },
  { name: "Betroka", region: "Anosy" },

  // ===================== COMMUNES & QUARTIERS D'ANTANANARIVO =====================
  { name: "Analakely", region: "Antananarivo", sub: true },
  { name: "Ambatomena", region: "Antananarivo", sub: true },
  { name: "Isotry", region: "Antananarivo", sub: true },
  { name: "Andavamamba", region: "Antananarivo", sub: true },
  { name: "Anosy (Antananarivo)", region: "Antananarivo", sub: true },
  { name: "Mahamasina", region: "Antananarivo", sub: true },
  { name: "Andohalo", region: "Antananarivo", sub: true },
  { name: "Andohatapenaka", region: "Antananarivo", sub: true },
  { name: "Ampefiloha", region: "Antananarivo", sub: true },
  { name: "Ambohijatovo", region: "Antananarivo", sub: true },
  { name: "Behoririka", region: "Antananarivo", sub: true },
  { name: "Tsaralalana", region: "Antananarivo", sub: true },
  { name: "Antanimena", region: "Antananarivo", sub: true },
  { name: "Ankorondrano", region: "Antananarivo", sub: true },
  { name: "Ivandry", region: "Antananarivo", sub: true },
  { name: "Alarobia", region: "Antananarivo", sub: true },
  { name: "Ankadifotsy", region: "Antananarivo", sub: true },
  { name: "Andravoahangy", region: "Antananarivo", sub: true },
  { name: "Ampasampito", region: "Antananarivo", sub: true },
  { name: "Ambohipo", region: "Antananarivo", sub: true },
  { name: "Ankatso", region: "Antananarivo", sub: true },
  { name: "Analamahitsy", region: "Antananarivo", sub: true },
  { name: "Ambohibao", region: "Antananarivo", sub: true },
  { name: "Ambohidahy", region: "Antananarivo", sub: true },
  { name: "Antaninandro", region: "Antananarivo", sub: true },
  { name: "Antanimora", region: "Antananarivo", sub: true },
  { name: "Andrainarivo", region: "Antananarivo", sub: true },
  { name: "Mahazoarivo", region: "Antananarivo", sub: true },
  { name: "Andraharo", region: "Antananarivo", sub: true },
  { name: "Ampandrianomby", region: "Antananarivo", sub: true },
  { name: "Fiadanana", region: "Antananarivo", sub: true },
  { name: "67ha", region: "Antananarivo", sub: true },
  { name: "Ampitatafika", region: "Antananarivo", sub: true },
  { name: "Itaosy", region: "Antananarivo", sub: true },

  // ===================== AUTRES COMMUNES IMPORTANTES =====================
  { name: "Talatamaty", region: "Analamanga" },
  { name: "Alasora", region: "Analamanga" },
  { name: "Ambohimanambola", region: "Analamanga" },
  { name: "Sabotsy-Namehana", region: "Analamanga" },
  { name: "Ivato Aéroport", region: "Analamanga" },
  { name: "Ankadikely-Ilafy", region: "Analamanga" },
  { name: "Mahitsy", region: "Analamanga" },
];

// Utilitaire : retourne la liste triée (villes majeures en tête)
export const getMadagascarCityOptions = () => {
  const majors = MADAGASCAR_CITIES.filter((c) => c.major).sort((a, b) => a.name.localeCompare(b.name));
  const others = MADAGASCAR_CITIES.filter((c) => !c.major).sort((a, b) => a.name.localeCompare(b.name));
  return [...majors, ...others];
};

// Recherche fuzzy (insensible casse + accents)
const strip = (s) => s.normalize("NFD").replace(/\p{Diacritic}/gu, "").toLowerCase();
export const searchMadagascarCities = (query, limit = 50) => {
  if (!query) return getMadagascarCityOptions().slice(0, limit);
  const q = strip(query);
  return MADAGASCAR_CITIES
    .filter((c) => strip(c.name).includes(q) || strip(c.region).includes(q))
    .slice(0, limit);
};
